import Vue from 'vue'
import Vuex from 'vuex'
import {RequestSession} from "./interfaces/requestSession";
import {Donation} from "@/interfaces/donation/donation";
import {Invoice} from "@/interfaces/economy/invoice";
import {Snackbar} from "@/interfaces/presentation/snackbar";
import {Dialog} from "@/interfaces/presentation/dialog";

Vue.use(Vuex)


class State {
  requestSession: RequestSession | null = null;
  donation: Donation | null = null;
  snackbar: Snackbar | null = null;
  invoice: Invoice | null = null;
  currentStep: number = 0;
  hideTaxReductionInfo: boolean = false;
  dialog: Dialog = {
    active: false,
    title: "",
    text: "",
    closeBtnText: "",
    actionBtnText: "",
    actionClick: () =>{}
  };
}

export default new Vuex.Store({
  state: new State(),
  mutations: {
    updateRequestSession(state, session: RequestSession)
    {
      state.requestSession = session
    },
    updateDonation(state, payload: Donation)
    {
      state.donation = payload
    },
    updateCurrentStep(state, payload: number)
    {
      state.currentStep = payload
    },
    createdInvoice(state, payload:Invoice)
    {
      state.invoice = payload
    },
    setSnackbar(state: State, snackbar: Snackbar) {
      // Default values
      let active = typeof snackbar.active !== "undefined" ? snackbar.active : true
      let color = snackbar.color ? snackbar.color : "primary"
      let timeout = snackbar.timeout ? snackbar.timeout : 6000 // 6 sec
      let text = snackbar.text ? snackbar.text : "Viktigt meddelande"


      // hide snackbar incase it is already showing
      if (state.snackbar?.active) {
        state.snackbar.active = false
      }
      // then we set the snackbar with proper values after a small delay
      window.setTimeout(() => {
        state.snackbar = {
          active: active,
          color: color,
          timeout: timeout,
          text: text,
          action: snackbar.action
        }
      }, 100)
    },
    setDialog(state, dialog) // dialog is used instead of confirmation alerts (e.g when confirming to delete an item)
    {
      // Default values
      let active = typeof dialog.active !== "undefined" ? dialog.active : true
      if (state.dialog?.active) {
        dialog.active = active
      }
      // hide dialog incase it is already showing (should not happen)
      state.dialog.active = false

      // then we set the dialog with proper values after a small delay
      window.setTimeout(() => {
        state.dialog = dialog
      }, 100)
    },
    updateHideTaxReductionInfo(state, value:boolean) {
      state.hideTaxReductionInfo = value
    },
  },
  actions: {

  }
})
